import CreateClient from "../CreateClient";
import PageBody from "../PageBody";

const NewClientPage = () => {
  return (
    <PageBody>
      <CreateClient />
    </PageBody>
  );
};

export default NewClientPage;
